<template>
  <div>
    <v-btn fab top right small @click="exportPayments">
      <v-icon>get_app</v-icon>
    </v-btn>
    <v-snackbar v-model="snackbar" multi-line color="success">
      <span>Estamos gerando seu relatório de pagamentos...</span>
      <v-btn flat color="white" @click="snackbar = false"
        ><v-icon>close</v-icon></v-btn
      >
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionCable from "actioncable";

export default {
  name: "PaymentsReport",
  data() {
    return {
      url: "",
      snackbar: false,
    };
  },
  watch: {
    url(newUrl) {
      window.open(newUrl);
    },
  },
  computed: {
    ...mapGetters({
      filterParams: "partners_payments/filterParams",
      systemAppName: "system/appName",
    }),
  },
  methods: {
    exportPayments() {
      this.snackbar = true;
      this.$store.state.partners_payments.filtersInitialDate =
        this.$store.state.partners_payments.filterParams.filterrific.with_created_at_between.start_at;
      this.$store.state.partners_payments.filtersFinalDate =
        this.$store.state.partners_payments.filterParams.filterrific.with_created_at_between.end_at;
      this.$store.dispatch("partners_payments/exportPayments", this.filterParams);
    },
  },
  created() {
    this.$store.dispatch('system/fetchSystemConfiguration');
    
    const cable = ActionCable.createConsumer(
      `${process.env.VUE_APP_WEBSOCKET_PROTOCOL}://${
        process.env.VUE_APP_FLOWIT_URL
      }/cable?token=${window.sessionStorage.getItem(`${this.systemAppName || process.env.VUE_APP_APP_NAME || 'flowit'}-session`)}`
    );
    
    /* eslint-disable */
    cable.subscriptions.create(
      {
        channel: "WebNotificationsChannel",
      },
      {
        connected: function () {
          // console.log('conectado');
        },
        disconnected: function () {
          // console.log('desconectado');
        },
        received: (data) => {
          if (data.event == "UserReporter.finished") {
            this.url = data.body;
          }
        },
      }
    );
  },
};
</script>
